module.exports = __webpack_public_path__ + "img/hyjmd2-img4.1c3a4154.png";